import { EventName } from 'plp/types/eventsObserver'
import { eventsObserver } from 'plp/utils/eventsObserver'
import { useEffect } from 'react'
import { debounce } from 'utils/debounce'

const LAST_CATALOG_SCROLL_PATH = 'lastCatalogScrollPath'
const SCROLL_DEBOUNCE_DELAY = 1000

export function useFirstScroll() {
	useEffect(() => {
		const isScrollFromSessionStorage = !!sessionStorage.getItem(
			LAST_CATALOG_SCROLL_PATH
		)

		function sendFirstScrollEvent() {
			eventsObserver.dispatch(EventName.FIRST_SCROLL)
		}

		const debouncedSendFirstScrollEvent = debounce(
			sendFirstScrollEvent,
			SCROLL_DEBOUNCE_DELAY
		)
		if (!isScrollFromSessionStorage) {
			window.addEventListener('scroll', debouncedSendFirstScrollEvent, {
				once: true,
			})
		}
		return () => {
			window.removeEventListener('scroll', debouncedSendFirstScrollEvent)
		}
	}, [])
}
